import React from 'react';

const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon-wrap"
    viewBox="0 0 30 30"
    width="16px"
    height="16px"
  >
    <path
      fill="#677892"
      fillRule="evenodd"
      d="M28.1 24.8V5.6c0-2.1-1.7-3.7-3.7-3.7H5.2C6.2.7 7.7 0 9.4 0h15C27.5 0 30 2.5 30 5.6v15c0 1.7-.7 3.2-1.9 4.2zM20.6 3.7c3.1 0 5.6 2.5 5.6 5.6V24.4c0 3.1-2.5 5.6-5.6 5.6h-15C2.5 30 0 27.5 0 24.4V9.4c0-3.1 2.5-5.6 5.6-5.6h15zM1.9 24.4c0 2.1 1.7 3.7 3.7 3.7h15c2.1 0 3.8-1.7 3.8-3.7V13.1H1.9v11.3zm0-15v1.9h22.5V9.4c0-2.1-1.7-3.7-3.8-3.7h-15c-2-.1-3.7 1.6-3.7 3.7zm15 0H3.8V7.5h13.1v1.9zm3.7 0h-1.9V7.5h1.9v1.9z"
      clipRule="evenodd"
    />
  </svg>
);

export default CopyIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/CopyIcon.js